import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "rsuite";
import { AiOutlineBell } from "react-icons/ai";
import Helper from "../../../Helper";

function Header() {

  let authUser = Helper.getStorageData('session');
  let navigate = useNavigate('/login');

  function logout(){
    localStorage.removeItem('session')
    navigate('/login/zekkmdvhkm')
  }

  return (
    <>
      <div className="top-bar primary-top-bar">
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <Link
                className="admin-logo"
                to={'/'}
              >
                <h1>
                  <img
                    alt=""
                    width="150"
                    src="/images/logo.png"
                    className="toggle-none hidden-xs"
                  />
                </h1>
              </Link>
              <div className="left-nav-toggle">
                <Link to="#" className="nav-collapse">
                  <i className="fa fa-bars"></i>
                </Link>
              </div>
              <div className="left-nav-collapsed">
                <Link to="#" className="nav-collapsed">
                  <i className="fa fa-bars"></i>
                </Link>
              </div>
              <ul className="list-inline top-right-nav">
                <li>
                  <Dropdown placement="bottomEnd" className="notification" icon={<AiOutlineBell />}>
                    <div className="header-dropdown">
                      <p>Notifications</p>
                      <a href="#">View All</a>
                    </div>
                    <Dropdown.Item>
                      <div className="notification-list">
                        <div className="img">
                          <img src="/images/avtar-2.png" alt="" />
                        </div>
                        <div className="text-box">
                          <p className="notification-title">Upload Complete</p>
                          <p className="notification-description">Lorem Ipsum is simply dummy text of the printing.</p>
                          <p className="notification-time">15 minutes ago</p>
                        </div>
                      </div>

                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div className="notification-list">
                        <div className="img">
                          <img src="/images/avtar-2.png" alt="" />
                        </div>
                        <div className="text-box">
                          <p className="notification-title">Upload Complete</p>
                          <p className="notification-description">Lorem Ipsum is simply dummy text of the printing.</p>
                          <p className="notification-time">15 minutes ago</p>
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown>
                </li>
                <li>
                  <Dropdown
                    className="user-profile-img"
                    title={ authUser?.name }
                    icon={
                      <img
                        width="30"
                        height="30"
                        className="rounded-circle"
                        src={ authUser?.image_url }
                      />
                    }
                  >
                    <Dropdown.Item>
                      <a onClick={logout}>Logout</a>
                    </Dropdown.Item>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default React.memo(Header)
